<script setup lang="ts">
import { REGULAR_EXPEDITIONS } from '~/shared/expedition'
</script>

<template>
  <UiContainer class="flex flex-col gap-11 py-7 lg:py-12">
    <UiSectionTitle
      class="text-center"
      title="Layanan Kargo Ekspedisi yang<br />Siap Penuhi Kebutuhan Pengirimanmu"
      description="Temukan berbagai layanan pengiriman kargo di KiriminAja. Informasi layanan dapat menyesuaikan sewaktu-waktu sesuai kebijakan ekspedisi."
    />
    <div class="flex justify-center">
      <div class="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 pb-8">
        <UiCourierService
          v-for="(expedition, index) in REGULAR_EXPEDITIONS.filter(
            (exp) => exp.cargo
          )"
          :key="index"
          :service-name="expedition.courier"
          :company="expedition.company_name"
          :icon="expedition.icon"
          :icon-class="expedition.class"
          class="flex-1 min-w-3xs max-w-xs"
        />
      </div>
    </div>
  </UiContainer>
</template>
